import React, { useState, useRef, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ReactToPrint from "react-to-print";
import NhanVayApi from "../../../../service/nhanVayApi";

export const BtnInTraLai = ({ nhanvayId }) => {
  const scrollRef = useRef();
  const dataIn = {
    printContent: "",
  };
  const [dataInThu, UpdateDataInThu] = useState(dataIn);

  const InPhieuThu = () => {
    NhanVayApi.getInTraLai(nhanvayId).then((response) => {
      UpdateDataInThu({
        ...dataInThu,
        printContent: response.data,
      });
    });
  };

  useEffect(() => {
    InPhieuThu();
  }, []);
  const ComponentToPrint = React.forwardRef((props, ref) => (
    <div
      className="col-sm-12"
      style={{ width: "100%", color: "#000000" }}
      ref={ref}
    >
      <div
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{ __html: props.data }}
      ></div>
    </div>
  ));
  return (
    <>
      <ReactToPrint
        trigger={() => {
          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
          // to the root node of the returned component as it will be overwritten.
          return (
            <button
              type="button"
              class="btn btn-new-main btn-checknew disk-mobile"
            >
              <span class="btn-icon-left">
                <i class="mdi mdi-printer"></i>
              </span>{" "}
              In danh sách
            </button>
          );
        }}
        content={() => scrollRef.current}
        copyStyles={false}
      />

      <div style={{ display: "none" }}>
        <ComponentToPrint data={dataInThu.printContent} ref={scrollRef} />
      </div>
    </>
  );
};
